import { api } from "../services/api";

export const getListSituacoes = async(tpservico)=>{

    api.defaults.headers.tpservico = tpservico
  
    return await api.get("/situacao/listar" )
    
  }